import moment from 'moment';
moment.locale('fr');

/********************************************Date Formating /********************************************/
export const getDateFromString = (string) => {
  if(!string || typeof string === "object") return string;

  var radix = 10;
  var arr = string.split("/");
  return new Date(parseInt(arr[2], radix), parseInt(arr[1], radix) - 1, parseInt(arr[0], radix));
}

export const getIsoStringFromDate = (dateObj) => {
  if(!dateObj) return;

  var year = dateObj.getFullYear()
  var month = dateObj.getMonth() + 1;
  var day = dateObj.getDate();

  if(month < 10) month = "0" + month.toString();
  if(day < 10) day = "0" + day.toString();

  return year + "-" + month + "-" + day;
}

export const getStringFromDate = (dateObj) => {
  if(!dateObj) return;

  var year = dateObj.getFullYear()
  var month = dateObj.getMonth() + 1;
  var day = dateObj.getDate();

  if(month < 10) month = "0" + month.toString();
  if(day < 10) day = "0" + day.toString();

  return day + "/" + month + "/" + year;
}

/********************************************Date Comparison /********************************************/
export const isSameDate = (dateObj1, dateObj2) => {
  if(dateObj1 instanceof Date && dateObj2 instanceof Date)
    return dateObj1.getFullYear() === dateObj2.getFullYear()
      && dateObj1.getMonth() === dateObj2.getMonth()
      && dateObj1.getDate() === dateObj2.getDate();

  return false;
}

export const daysDiff = (start, end) => {
  if(start instanceof Date && end instanceof Date) {
    const diff = end - start;
    return diff / (1000*60*60*24);
  }

  return null;
}
/********************************************Date Accessors /********************************************/
export const getDaysInYear = (year) => {
  if(year === undefined) {
    const date = new Date();
    year = date.getFullYear();
  }

  const start = new Date(year, 0, 0), end = new Date(year, 11, 31);
  return daysDiff(start, end);
}

export const getWeeksInYear = (year) => {
  if(year === undefined) {
    const date = new Date();
    year = date.getFullYear();
  }

  const getWeekNumber = (d) => {
    // Copy date so don't modify original
    d = new Date(+d);
    d.setHours(0, 0, 0);
    // Set to nearest Thursday: current date + 4 - current day number
    // Make Sunday's day number 7
    d.setDate(d.getDate() + 4 - (d.getDay()||7));
    // Get first day of year
    const yearStart = new Date(d.getFullYear(),0,1);
    // Calculate full weeks to nearest Thursday
    const weekNo = Math.ceil(( ( (d - yearStart) / 86400000) + 1)/7)
    // Return array of year and week number
    return [d.getFullYear(), weekNo];
  }

  const d = new Date(year, 11, 31);
  const week = getWeekNumber(d)[1];
  return week === 1 ? getWeekNumber(d.setDate(24))[1] : week;
}



// WEBPACK FOOTER //
// ./src/Utils/Date.js